import styled from 'styled-components'
import * as All from '../BaseStyles'

export const SectionDiv = styled(All.Div)`
    box-shadow:
    0 0px 2px rgba(0, 0, 0, 0.022),
    0 0px 3px rgba(0, 0, 0, 0.031),
    0 0px 4px rgba(0, 0, 0, 0.039),
    0 0px 5px rgba(0, 0, 0, 0.048),
    0 0px 6px rgba(0, 0, 0, 0.07)
    ;
    margin: 8rem 0rem;
    background-color: white;
    border-radius: 1.5rem;
    padding: 2rem;
`

export const HeaderDiv = styled(All.Div)`
    width: 100%;
`

export const FormDiv = styled(All.Div)`
    padding-top: 2.5rem;
    border-color: #d7d7d7;
`

export const SectionHeader = styled(All.SectionHeader)`
    font-size: 3rem;
    margin: 0;
    padding: 0;
    display: inline-block;
`

export const SettingRowDiv = styled(All.Div)`
    width: 100%;
    padding: 0.5rem 0rem;
    overflow: hidden;
`

export const LeftSettingDiv = styled(All.Div)`
    width: 49.5%;
    margin: 0% 0.5% 0% 0%;
    display: inline-block;
`

export const MiddleSettingDiv = styled(All.Div)`
    width: 33%;
    margin: 0% 0.25%;
    display: inline-block;
`

export const RightSettingDiv = styled(All.Div)`
    width: 49.5%;
    margin: 0% 0% 0% 0.5%;
    float: right;   
    display: inline-block;
`

export const FullSettingDiv = styled(All.Div)`
    width: 100%;
    display: inline-block;
`

export const SettingHeader = styled.p`
    margin: 0;
    padding: 0;
    margin-bottom: 0.4rem;
    font-size: 1.6rem;
`

export const InputField = styled(All.InputField)`
    font-size: 1.6rem;
    width: 100%;
    height: 3rem;
`

export const ActionButton = styled.button`
    margin: 0;
    padding: 0.6rem 0.8rem;
    font-size: 1.6rem;
    color: black;
    outline-styles: none;
    border-radius: 0.7rem;
    border-style: solid;
    border-width: thin;
    cursor: pointer;
`

export const CancelButton = styled(ActionButton)`
    margin: 0rem 1rem 0rem 0rem;
    background-color: transparent;
    border-color: #e11313;
    &:hover{
        background-color: #e11313;
    }
`

export const SaveButton = styled(ActionButton)`
    margin: 0rem 1rem 0rem 0rem;
    background-color: transparent;
    border-color: green;
    &:hover{
        background-color: green;
    }
`

export const ConfirmationPhrase = styled.h2`
    margin: 0;
    padding: 0;
    font-size: 2rem;
    color: black;
    font-weight: 300;
`